import React, { useState } from "react";
import { db } from "../../firebase"; // Adjust path as needed
import { collection, query, where, getDocs } from "firebase/firestore";

function SearchApplication() {
  const [mobileSearch, setMobileSearch] = useState("");
  const [applicationData, setApplicationData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setApplicationData(null);

    try {
      // Query Firestore for the mobile number
      const q = query(
        collection(db, "teacher_from_data"), 
        where("mobile", "==", mobileSearch)
      );
      
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        setError("No application found with this mobile number.");
      } else {
        // Take the first matching document
        const data = querySnapshot.docs[0].data();
        setApplicationData(data);
      }
    } catch (err) {
      console.error("Search Error:", err);
      setError("An error occurred while fetching data.");
    }
    setLoading(false);
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="container mt-4">
      {/* --- Internal CSS for Printing --- */}
      <style>
        {`
          @media print {
            body * { visibility: hidden; }
            #printableReceipt, #printableReceipt * { visibility: visible; }
            #printableReceipt { 
              position: absolute; 
              left: 0; 
              top: 0; 
              width: 100%; 
              border: 1px solid #000; 
              padding: 20px;
            }
            .no-print { display: none !important; }
          }
        `}
      </style>

      {/* --- Search Box (Hidden during print) --- */}
      <div className="card p-4 shadow-sm mb-4 no-print">
        <h3 style={{color:"#ED1B24"}} className="text-center mb-4">Print Your Application</h3>
        <form onSubmit={handleSearch} className="d-flex gap-2">
          <input
            type="text"
            className="form-control form-control-lg"
            placeholder="Enter Registered Mobile Number"
            value={mobileSearch}
            onChange={(e) => setMobileSearch(e.target.value)}
            required
            maxLength="10"
          />
          <button type="submit" className="btn btn-primary px-4" disabled={loading}>
            {loading ? "Searching..." : "Search"}
          </button>
        </form>
        {error && <div className="alert alert-danger mt-3">{error}</div>}
      </div>

      {/* --- Result / Receipt View --- */}
      {applicationData && (
        <div className="mt-4">
          <div id="printableReceipt" className="card p-4 shadow-sm border-primary">
            <div className="text-center mb-4">
              <h2 className="text-primary">Astha Digital Services</h2>
              <p className="fw-bold">Application Form Details</p>
              <hr />
            </div>

            <div className="row">
              <div className="col-8">
                <h4><b>{applicationData.name}</b></h4>
                <p className="mb-1"><b>Post:</b> {applicationData.postname}</p>
                <p className="mb-1"><b>Guardian:</b> {applicationData.guardianname}</p>
                  <p className="mb-1"><b>Date of Birth:</b> {applicationData.dateofbirth}</p>
                <p className="mb-1"><b>Mobile:</b> {applicationData.mobile}</p>
                  <p className="mb-1"><b>Email:</b> {applicationData.email}</p>

                <p className="mb-1 text-success"><b>Payment ID:</b> {applicationData.paymentId}</p>
              </div>
              <div className="col-4 text-center">
                <img 
                  src={applicationData.photoURL} 
                  alt="Applicant" 
                  style={{ width: "120px", height: "140px", border: "1px solid #ddd", objectFit: "cover" }} 
                />
              </div>
            </div>

            <table className="table table-bordered mt-4">
              <thead className="table-light">
                <tr>
                  <th>Qualification</th>
                  <th>Passing Year</th>
                  <th>Percentage</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>MP (Secondary)</td><td>{applicationData.mpYear}</td><td>{applicationData.mpPercentage}%</td></tr>
                {applicationData.hsYear && <tr><td>HS (Higher)</td><td>{applicationData.hsYear}</td><td>{applicationData.hsPercentage}%</td></tr>}
                {applicationData.gradYear && <tr><td>Graduation</td><td>{applicationData.gradYear}</td><td>{applicationData.gradPercentage}%</td></tr>}
              </tbody>
            </table>

            <div className="row mt-3">
                <h6 className="bg-light p-2">Computer Details</h6>
                                <p className="mb-1"><b><small>Computer Course Name:</small></b> {applicationData.computercoursename}</p>
                              <p className="mb-3"><b><small>Year of Passing:</small></b> {applicationData.yearofpassing}</p>
               <div className="col-12">

                  <p className="mb-1"> <b>Address:</b> {applicationData.address}, {applicationData.district}, PIN: {applicationData.pincode}</p>
                  <p className="mb-1"><b>Nearest School:</b> {applicationData.nearestschoolname}</p>
                     <p><b>Category:</b> {applicationData.category}</p>
               </div>
            </div>

            <div className="d-flex justify-content-between align-items-end mt-5">
              <div>
                <p className="small text-muted">Application Date: {applicationData.submissionDate || "N/A"}</p>
              </div>
              <div className="text-center">
                <img src={applicationData.signatureURL} alt="Sign" style={{ width: "130px", maxHeight: "50px" }} />
                <p className="mb-0 border-top mt-1">Applicant Signature</p>
              </div>
            </div>
          </div>

          <div className="text-center mt-4 no-print">
            <button className="btn btn-success btn-lg px-5 shadow" onClick={handlePrint}>
              Print Application Form
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default SearchApplication;